import { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel
} from '@mui/material';
import LoadingSpinner from '../../../../../animation/LoadingSpinner';
import { H6, Body2, Body3, Body1 } from '../../../../../themes/typography';
import '../../../../../styles/components/Invitation.css';

function AttendeesList({ attendeesList, loading }) {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [data, setData] = useState([...attendeesList]);

    useEffect(() => {
        setData([...attendeesList]);
    }, [attendeesList]);

    const handleSort = () => {
        const isAsc = orderBy === 'name' && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy('name');

        const sortedData = [...data].sort((a, b) => {
            // Handle null/undefined values by providing empty string as fallback
            const nameA = a['attendee_name'] || '';
            const nameB = b['attendee_name'] || '';

            if (newOrder === 'asc') {
                return nameA.localeCompare(nameB);
            } else {
                return nameB.localeCompare(nameA);
            }
        });

        setData(sortedData);
    };


    return (
        <div className="invitation-list-container">
            <TableContainer sx={tableContainerStyle}>
                <Table stickyHeader aria-label="attendees table" sx={{ tableLayout: 'fixed', width: '100%' }}>
                    <TableHead sx={dataCellStyle}>
                        <TableRow sx={dataCellStyle}>
                            <TableCell align="left" sx={{ ...headerCellStyle, width: '25%' }}>
                                <TableSortLabel
                                    direction={order}
                                    active={orderBy === 'name'} // to hide the sort icon and only show on
                                    onClick={handleSort}
                                    sx={{
                                        gap: '0.5rem',
                                        '& .MuiTableSortLabel-icon': {
                                            color: 'var(--secondary-color) !important'
                                        }
                                    }}
                                >
                                    <H6>Customer Details</H6>
                                </TableSortLabel>
                            </TableCell>

                            <TableCell align="center" sx={{ ...headerCellStyle, width: '15%' }}>
                                <H6>Ticket Name</H6>
                            </TableCell>

                            <TableCell align="center" sx={{ ...headerCellStyle, width: '15%' }}>
                                <H6>Booking Id</H6>
                            </TableCell>

                            <TableCell align="center" sx={{ ...headerCellStyle, width: '15%' }}>
                                <H6>Ticket Id</H6>
                            </TableCell>

                            <TableCell align="center" sx={{ ...headerCellStyle, width: '20%' }}>
                                <H6>Booked on</H6>
                            </TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && data?.map((row, index) => (
                            <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                                sx={{
                                    borderBottom: '1px solid var(--divider-color)'
                                }}
                            >
                                <TableCell align="left" sx={dataCellStyle}>
                                    <div style={attendeeDetail}>
                                        <Body1>{row.attendee_name}</Body1>
                                        <Body3>{row.email}</Body3>
                                        <Body3>{row.phone}</Body3>
                                    </div>
                                </TableCell>

                                <TableCell align="center" sx={dataCellStyle}>
                                    <Body2>{row.ticket_type}</Body2>
                                </TableCell>

                                <TableCell align="center" sx={dataCellStyle}>
                                    <Body2>{row.booking_number}</Body2>
                                </TableCell>

                                <TableCell align="center" sx={dataCellStyle}>
                                    <Body2>{row.ticket_number}</Body2>
                                </TableCell>

                                <TableCell align="center" sx={dataCellStyle}>
                                    <Body2>{row.booked_on}</Body2>
                                </TableCell>

                            </TableRow>
                        ))}

                        {!loading && data?.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={5} align="center" sx={dataCellStyle}
                                >
                                    <Body1>No attendees record found.</Body1>
                                </TableCell>
                            </TableRow>
                        )}

                        {loading && (
                            <TableRow>
                                <TableCell colSpan={5} align="center" sx={{ borderBottom: 'none' }}>
                                    <LoadingSpinner
                                        message='Loading attendees list...'
                                    />
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

export default AttendeesList;

const attendeeDetail = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '0.25rem'
};

const tableContainerStyle = {
    borderTopRightRadius: '1rem',
    borderTopLeftRadius: '1rem',
    maxHeight: '70vh'
};

const headerCellStyle = {
    backgroundColor: '#283853',
    borderBottom: 'none'
};

const dataCellStyle = {
    borderBottom: '1px solid rgba(153, 166, 173, 0.35)'
};
